module.exports = __webpack_public_path__ + "syndic.01e30706a3f8d88db8577dc360425519.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/base/components/home/syndic.png
// module id = 279
// module chunks = 0